import {
    WALLET_SUCCESSFUL_GET,
    SHOW_ERROR_MESSAGE,    
    WALLET_UPDATE_FILTERTRANSACTIONTYPE,
    WALLET_UPDATE_FILTERACCOUNTTRANSTYPE,
    WALLET_UPDATE_FILTERSTARTDATE,
    WALLET_UPDATE_FILTERENDDATE,
    WALLET_SUCCESSFUL_BALANCE_AMOUNT
} from 'reducers/constants';

import HttpClient from "utils/HttpClient/HttpClient"

export const fetchAccountInfo = (requestData, resolve, reject) => dispatch => {
    new HttpClient(true).get("oga/account/filter", {
        params: requestData
    })
        .then((response) => {
            dispatch({
                type: WALLET_SUCCESSFUL_GET,
                payload: response.data
            });
            resolve();
        })
        .catch((error) => {
            dispatch({
                type: SHOW_ERROR_MESSAGE,
                payload: error.message
            });
            resolve();
        });
}

export const updateFilterTransactionType = (data) => dispatch => {
    dispatch(
        {
            type: WALLET_UPDATE_FILTERTRANSACTIONTYPE,
            payload: data
        }
    )
}

export const updateFilterAccountTransType = (data) => dispatch => {
    dispatch(
        {
            type: WALLET_UPDATE_FILTERACCOUNTTRANSTYPE,
            payload: data
        }
    )
}

export const updateFilterStartDate = (date) => dispatch => {
    dispatch(
        {
            type: WALLET_UPDATE_FILTERSTARTDATE,
            payload: date
        }
    )
}

export const updateFilterEndDate = (date) => dispatch => {
    dispatch(
        {
            type: WALLET_UPDATE_FILTERENDDATE,
            payload: date
        }
    )
}

export const fetchAccountBalance = () => dispatch => {
    new HttpClient(true).get("oga/account/balance")
        .then((response) => {
            dispatch({
                type: WALLET_SUCCESSFUL_BALANCE_AMOUNT,
                payload: response.data
            });
        })
        .catch((error) => {
            dispatch({
                type: SHOW_ERROR_MESSAGE,
                payload: error.message
            });
        });
}

export const saveTransfer = (dto, resolve, reject) => dispatch => {
    new HttpClient(true).post("oga/account/transfer", dto)
        .then((response) => {
            resolve("Successful");
        })
        .catch((error) => {            
            dispatch({
                type: SHOW_ERROR_MESSAGE,
                payload: error.response.data.message
            });
            reject("Failed");
        })
}


// WEBPACK FOOTER //
// ./src/reducers/wallet/walletActions.js